import { render, staticRenderFns } from "./devolutionTicket.vue?vue&type=template&id=c57b0842"
import script from "./devolutionTicket.vue?vue&type=script&lang=js"
export * from "./devolutionTicket.vue?vue&type=script&lang=js"
import style0 from "./devolutionTicket.vue?vue&type=style&index=0&id=c57b0842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports